module.exports = __webpack_public_path__ + "img/ereszkalkulator_24_konyoktipusa_bal_konyok_fekete.1530b29d.png";